import styled from "styled-components";

export const InfoBarContainer = styled.div`
.table-container{
    border-radius: 8px;
    background-color: #33363C;
    padding: 10px 25px;
    // transition: width 0.2s ease-out;
}
.inputData_table_searchable .css-1tbggly {
    background-color: #33383c !important;
    // border: 1px solid #f5f5f54d !important;
    min-height: 4.5rem;
  }
  .inputData_table_searchable
    .css-78trlr-MuiButtonBase-root-MuiIconButton-root {
    color: #fff;
  }
  .dataIndex_table{
    min-height: 100px; 
  }
  .dataIndex_table .ant-spin-nested-loading{
    min-height: 100px;
  }
  .inputData_table_searchable tbody tr.MuiTableRow-root {
    background-color: #33383c !important;
  }
  .inputData_table_searchable .css-10gei56 {
    background-color: #33383c !important;
    min-height: 4.5rem;
  }
  .inputData_table_searchable {
    border: 1px solid #f5f5f54d !important;
    border-radius: 8px;
  }
  .dataIndex_table .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 {
    color: #fff;
    width: 100%;
    box-shadow: none;
    border: none;
    border-radius: 0px;
  }
  .inputData_table_searchable .MuiTablePagination-root .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-animated.MuiFormLabel-colorPrimary.MuiInputLabel-root.MuiInputLabel-animated {
    color: #fff;
    font-size: 14px;
  }
  .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary {
    color: #36BDBE;
    font-size: 14px;
  }
  .inputData_table_searchable .MuiTablePagination-root .MuiInputBase-root.MuiInput-root.MuiInputBase-colorPrimary svg{
    color: #36BDBE !important;
    font-size: 22px;
  }
  .inputData_table_searchable .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
    color: #36BDBE !important;
    font-size: 22px;
  }
  .dataIndex_table button.Mui-disabled[area-label="Clear search"] {
    background-color: transparent;
    // color: #ffffff !important;
  }
  .dataIndex_table button[area-label="Clear search"] {
    background-color: transparent;
    color: #ffffff !important;
    padding: 2px 2px;
  }
  .dataIndex_table button[area-label="Clear search"]:focus{
    border-radius: 0px;
  }
  .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {
    color: #fff;
    padding: 0px 10px;
    background: rgba(255, 255, 255, 0.24);
  }
  .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input{
    padding: 3px 0px;
    font-size: 14px;
    color: #ffffff;
  }
  .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd input::placeholder {
    color: #ffffff;
  }
  .dataIndex_table .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd fieldset{
    border: none;

  }
    .dataIndex_table svg[data-testid="SearchIcon"]{
        font-size: 20px;
}
  .inputData_table_searchable
    .MuiCollapse-wrapper.MuiCollapse-horizontal.css-18w3a48-MuiCollapse-wrapper {
    border: 1px solid #f5f5f54d !important;
    display: block !important;
    border-radius: 5px;
  }
  .inputData_table_searchable .MuiTableCell-head svg[data-testid="SyncAltIcon"] {
      color: #fff !important;
  }
  .inputData_table_searchable
    .Mui-TableHeadCell-Content-Actions.MuiBox-root.css-epvm6 {
    display: none !important;
  }
  // .inputData_table_searchable .css-i4bv87-MuiSvgIcon-root {
  //   font-size: 20px;
  // }
  .inputData_table_searchable .css-8k4lth {
    padding: 8px 0px;
  }
  // .inputData_table_searchable .css-1f2oslk-MuiTypography-root {
  //   font-size: 14px;
  // }
  .inputData_table_searchable
    .MuiSvgIcon-root[data-testid="CloseIcon"]  {
    font-size: 20px;
  }
  .inputData_table_searchable
    .MuiIconButton-root[aria-label="Clear search"] {
    color: rgb(196 192 192 / 54%);
  }
  .inputData_table_searchable
    .MuiIconButton-root[aria-label="Toggle full screen"] {
    display: none;
  }
  .inputData_table_searchable .MuiIconButton-root[aria-label="Toggle density"] {
    display: none;
  }
  .inputData_table_searchable
    .MuiIconButton-root[aria-label="Show/Hide columns"] {
    display: none;
  }
  .inputData_table_searchable
    .MuiIconButton-root[aria-label="Show/Hide filters"] {
    display: none;
  }
  .inputData_table_searchable .MuiTableSortLabel-icon {
    display: none !important;
  }
  .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root {
    max-height: 450px;
  }
  .inputData_table_searchable
    .MuiCollapse-root.MuiCollapse-horizontal.MuiCollapse-entered.css-1d98dbz-MuiCollapse-root {
    display: block !important;
  }
  .inputData_table_searchable
    .css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input::placeholder {
    color: #fff !important;
  }
  .inputData_table_searchable {
    margin-top: 0px;
    min-width: 450px;
  }
  .inputData_table_searchable th {
    border-color: #f5f5f54d;
    background-color: #33383ccc;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    padding: 6px 10px;
    border: none;
  }
  .inputData_table_searchable td {
    border-color: #f5f5f54d;
    font-size: 14px;
    padding: 8px 8px;
    border: none;
    color: #fff;
  }
  .info-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fff;
    cursor: pointer;
}

.info-icon-container span {
    color: #000;
}
.inputData_table_searchable td:last-child span{
    display: flex;
    justify-content: center;
    align-items: center;
}
.inputData_table_searchable td:first-child{
    text-align:left;
}
.dataIndex_table .css-zrlv9q , .dataIndex_table .css-wsew38{
    justify-content: start;
}
// .dataIndex_table .css-14vyde3-MuiCollapse-wrapperInner{
//     width:250px;
// }
.dataIndex_table .MuiFormControl-root.MuiTextField-root ,.dataIndex_table .MuiFormControl-root.MuiTextField-root {
    width:250px;
}
.inputData_table_searchable .css-euw4nl-MuiTableRow-root{
    background-color: #33383c !important;
}
.inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root{
    color: #fff !important;
}
.inputData_table_searchable .css-1ezkbdg-MuiButtonBase-root-MuiRadio-root.Mui-checked {
    color: #fff !important;
}
.inputData_table_searchable .css-1yq237c-MuiTableRow-root.Mui-selected {
    background-color: rgb(0 122 122) !important;
}
.inputData_table_searchable  .css-1yq237c-MuiTableRow-root td:after{
    background-color: transparent;
}
.inputData_table_searchable .selected-row {
    background-color: #e6f7ff; // Light blue as an example
  }
  .inputData_table_searchable .MuiTablePagination-root .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root {
    color: #36BDBE;
    // padding: 5px 0px;
  }
 .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to first page"],
  .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to previous page"],
  .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to next page"],
  .inputData_table_searchable .MuiTablePagination-root button.Mui-disabled[aria-label="Go to last page"] {
      color: rgba(255, 255, 255, 0.2) !important;
      border-radius: 6px;
      padding: 3px 3px;
  }

  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"],
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"],
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"],
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] {
      color: #36BDBE !important;
      border-radius: 6px;
      padding: 3px 3px;
  }

  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to first page"] svg,
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to previous page"] svg,
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to next page"] svg,
  .inputData_table_searchable .MuiTablePagination-root button[aria-label="Go to last page"] svg {
      font-size: 27px !important;
  }
  .dataIndex_table .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation2 .MuiTablePagination-root .MuiTypography-root.MuiTypography-body2.MuiTypography-alignCenter{
      font-size: 14px;
  }
  .materialReactTableCustom{
    width: 500px;
    // transition: width 0.2s ease-out; 
  }
  .materialReactTableCustom.expand{
    width: 100%;
  }
  .table-container ant-tabs-tab-active{
    padding: 12px 20px 8px 20px !important;
  }
  .table-container nt-tabs-tab.ant-tabs-tab-active{
    color: #33383c !important;
  }
  .actionIconBox{
    gap: 10px !important;
    display: flex;
    min-width: 170px !important;
}
.inputData_table_searchable{
    border: none !important;
}
.custom-tabs .ant-tabs-tab {
    padding: 12px 25px 8px 25px;
    margin: 0 10px 0 0;
}
.custom-tabs .ant-tabs-tab-btn {
  color: #64666B; 
  font-size: 16px;
  font-weight: 600;
} 
.custom-tabs .ant-tabs-tab-btn:focus{
  color: #64666B; 
}
.custom-tabs .ant-tabs-tab-btn:hover{
  color: #36BDBE; 
}
.custom-tabs .ant-tabs-tab-btn:focus-visible{
  outline: none; 
}
.custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #36BDBE; 
}

.custom-tabs .ant-tabs-ink-bar {
    background-color: #36BDBE;
}
.custom-tabs > .ant-tabs-nav::before {
    border-color: #6A727C;
}
.custom-select-dropdown .ant-select-selector {
    background: rgba(255, 255, 255, 0.24) !important;
    color: #ffffff;
    border: none !important;
}

.custom-select-dropdown .ant-select-arrow {
    color: #ffffff;
    font-size: 16px;
}
.custom-select-dropdown .ant-select-arrow .anticon >svg{
  height: 1.2rem !important;
}
.materialReactTableCustom .css-qpxlqp{
  left: 0;
  right: unset;
}
.custom-select-dropdown .ant-select-item {
    color: #ffffff; 
}
.custom-select-dropdown{
    min-width: 120px;
    height: 28px;
}
.custom-select-dropdown .ant-select-selection-item {
    color: #ffffff;
    padding-inline-end: 23px;
}
.table_checkbox_section .ant-checkbox .ant-checkbox-inner{
  background-color: transparent;
}
.materialReactTableCustom .MuiTablePagination-root .css-192dx0w span:nth-child(2){
  margin-right: 10px;
}
.button-name{
  background-color: transparent;
  color: #36BDBE;
  text-decoration: underline;
  cursor: pointer;
} 
.button-name:hover{
  background-color: transparent;
  color: #ffffff;
} 
.button-name:focus{
  outline: none;
}
.materialReactTableCustom .button-name-disabled{
  background-color: transparent;
  color: gray;
}
.dataIndex_table table th:last-child{
  position: sticky;
  right: 0;
  z-index: 99;
  background-color: #303336cc;
}
.dataIndex_table table td:last-child {
  position: sticky;
  right: 0;
  z-index: 99;
  background-color: #303336;
}
.dataIndex_table table td:last-child .css-1mwzkr2-MuiTypography-root{
  color: #ffffff;
  font-size: 14px;
  font-style: normal;
}
.materialReactTableCustom .css-wsew38{
  gap: 10px;
  padding: 0px;
}
.custom-tab-container{
  position: relative;
  min-width: 300px;
}
.tab-icons{
  position: absolute;
  display: flex;
  gap: 3px;
  top: 12px;
  right: 0;
}
.tab-icons svg, .actionIconBox svg {
  transition: transform 0.2s ease-in-out; 
  cursor: pointer; /* Adjust timing and easing to your preference */
}
.tab-icons svg:hover, .actionIconBox svg:hover{
  transform: scale(1.2);
}
.inputData_table_searchable .materialReactTableCustom td{
  border-bottom: 1px solid #6A727C;
}
.inputData_table_searchable .materialReactTableCustom.expand td{
  border-bottom: 1px solid #6A727C;
}


.materialReactTableCustom .ant-checkbox-inner {
  background-color: transparent;
  border: 2px solid #ffffff;
}
.materialReactTableCustom .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #007a7a;
  border-color: #007a7a;
  border: 2px;
}

.materialReactTableCustom
  .ant-checkbox-indeterminate
  .ant-checkbox-inner:after {
  background-color: #007a7a;
}
.materialReactTableCustom span.ant-checkbox-inner:hover {
  border-color: #ffffff !important;
}
.loading_box .ant-spin-dot-item {
  background-color: #36BDBE; /* Change to your desired color */
}
.batch_btn{
  height: 28px;
  background-color: #36BDBE;
  border: none;
}
.batch_btn:disabled{
  opacity: 0.5;
  color: #ffffff !important;
}
.batch_btn:disabled:hover{
  opacity: 0.5;
}
.batch_btn:hover{
  height: 28px;
  background-color: #36BDBE !important;
  color: #ffffff !important;
  border: none;
}
.batch_btn:focus{
  outline: none;
  box-shadow: none;
}
.name_btn{
  display: flex;
  gap: 10px;
}
.infoIcon svg{
  color: #ffffff;
  width: 17px;
}
.infoIcon:hover svg{
  color: #36BDBE;
}

// batch detail page css
.batch_info{
  padding: 10px 0px;
}
.batch_info p{
  display: block;
  margin: 0px;
  margin-bottom: 5px;
  color: #ffffff;
  font-size: 15px;
}

.batchCustomTable{
  width: 100%;
}

.batchCustomTable .css-zrlv9q {
  padding-left: 0px;
  gap: 0px;
}

.batchCustomTable .css-wsew38{
gap: 0px;
padding: 0px;
}

.inputData_table_searchable .batchCustomTable td{
border-bottom: 1px solid #6A727C;
}
.table_batch_container{
// margin: 10px 0px;
}
.table_batch_container .ant-tabs-content-holder{
// height: calc(100vh - 120px) !important;
}


// create batch modal css
.add_batch_block{
padding-bottom: 15px;
}
.custom_batch_input{
min-width: 200px;
width: fit-content;
}
.custom_batch_input{
background: rgba(255, 255, 255, 0.24) !important;
color: #ffffff;
border: none !important;
}
.custom_batch_input.ant-input-disabled{
color: #bebebe;
background: rgba(255, 255, 255, 0.5) !important;
}

// aois table css

.aois_table .css-zrlv9q{
gap: 0px;
padding-left: 0px;
}  
// .aois_table_pagination li{
//   vertical-align: middle;
// }
// .aois_table_pagination .ant-pagination.ant-pagination-simple .ant-pagination-prev button, .aois_table_pagination .ant-pagination.ant-pagination-simple .ant-pagination-next button{
//   color: #36BDBE;
// }
//  .aois_table_pagination .ant-pagination.ant-pagination-simple .ant-pagination-prev .ant-pagination-disabled button, .aois_table_pagination .ant-pagination.ant-pagination-simple .ant-pagination-next .ant-pagination-disabled button{
//   color: gray;
// }
// .aois_table_pagination input{
//   color: #36BDBE;
//   font-weight: 600;
// }
.load_aoi_btn{
color: #36BDBE;
cursor: pointer;
text-decoration: underline;
background: transparent;
border: none;
padding: 0px;
}
.load_aoi_btn span{
color: #36BDBE
}
.load_aoi_btn span:hover{
color: #ffffff !important;
}
.load_aoi_btn:disabled span{
color: gray;
}
.load_aoi_btn:disabled{
cursor: no-drop;
}
.load_aoi_btn:active{
outline: none;
color: #ffffff;
}
.load_aoi_btn:disabled:active{
outline: none;
color: gray;
}
.load_aoi_btn:focus{
outline: none;
color: #ffffff;
}
.load_aoi_btn:focus-visible{
outline: none;
color: #ffffff;
}
.load_aoi_btn:focus:active{
outline: none;
color: gray;
}
.material_menu_table .MuiBox-root .css-1llu0od{
display: block !important;
}
.material_menu_table .MuiBox-root .css-nokk8{
justify-content: start;
}
.create_batch_block{
padding-top: 10px;
}

// batch details page css
.batch_info .css-zrlv9q{
padding: 0px;
gap: 0px;
}
.batch-details-operation-btns{
display: flex;
gap: 10px;
margin-bottom: 10px;
}
// upload table css
.uploadMenuTable .ant-progress-inner{
font-size: 15px !important;
}
.quota-section-title{
  font-size: 16px;
  color: #ffffff;
  width: fit-content;
  padding: 0px 36px;
  padding-bottom: 5px;
  border-bottom: 1px solid #6A727C;
  text-transform: capitalize;
}
.quota-section{
  text-align: center;
  margin-bottom: 25px;
}
.progress_detail_box{
  display: flex;
  gap: 20px;
  margin-top: 25px;
}
.progress_inner_detail_box{
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;

}
.available_data_box{
  width: 29px;
  height: 29px;
  background: #5C5E63;
}
.available_data_info{
  display: block;
  text-align: left;
  line-height: 19px;
}
.fill_data_box{
  background: #36BDBE;
}
.info_title_text{
  color: #ffffff;
  font-size: 14px;
  display: block;
  margin: 0px;
}
.info_title_inner_text{
  color: #ffffff;
  font-size: 12px;
  display: block;
  margin: 0px;
}
.progress_inner_detail_box{
  justify-content: end;
}
.progress_inner_detail_box_right{
  justify-content: start !important;
}
.loading_block{
  min-height: 200px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 20px;
}
.loading_block .ant-spin-dot-item {
  background-color: #36BDBE;
}

.bottom-right {
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 10px;
    z-index: 1000;
    background-color: #e1e1e1;
    border-radius: 5px;
    border: 1px solid #000;
}
.active-projection {
    font-weight: bold;
}
.info_main_box{
  display: flex;
  justify-content: space-between;
  padding: 15px 0px;
}
.info_inner_box{
  flex: 1;
  color: #ffffff;
}
.info_main_box h3{
  margin-bottom: 16px;
  color: #ffffff;
}
.info_label{
  padding-right: 10px;
}
.info_row{
  padding-top: 10px;
  padding-bottom: 3px;
  border-bottom: 1px solid #6A727C4D;
  display: flex;
}
.info_unit_row{
  display: flex;
  align-items: center;
}
.info_unit_row svg{
  width: 16px;
  height: 16px;
}
.info_inner_left_box{
  padding-right: 13px;
}
.info_inner_right_box{
  padding-left: 13px;
  border-left: 1px solid #6A727C;
}
.info_inner_main_box h3{
    margin-bottom: 0px;
}
.info_inner_main_box{
  padding-bottom: 0px;
}
.info_inner_main_box_right{
    padding-left: 25px;
}
.main_width_title{
  display: none;
}
.main_title{
  display: block;
}
.no_data_box{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 16px;
}

@media only screen and (max-width: 600px) {
    .inputData_table_searchable .css-14vyde3-MuiCollapse-wrapperInner {
        width: 150px; 
    }

    .inputData_table_searchable .css-11sh9fj-MuiFormControl-root-MuiTextField-root, .inputData_table_searchable .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
        width: 150px;
    }
  }
  @media only screen and (max-width: 1400px) {
    .inputData_table_searchable .materialReactTableCustom.expand{
      width: 83vw;
    }
    .inputData_table_searchable .css-nhjqqh-MuiTableContainer-root{
      max-height: 400px;
    }
  }

  @media only screen and (max-width: 992px) {
    .info_main_box{
      display: block;
    }
    .main_width_title{
      display: block;
      padding-left: 0px;
    }
    .main_title{
      display: none;
    }
    .info_inner_right_box{
      padding-left: 0px;
      border-left: 0px;
      margin-top: 30px;
    }
    .info_inner_main_box h3, .info_main_box h3{  
      font-size: 18px;
    }
  }

`;
